import React from 'react';
import { Controller } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Select from "react-select";
import dayjs from 'dayjs';
import { optionsTransportOrderStatus } from '../../../common/constant';
import DepartmentTreeSelect from '../../list-department/components/department-tree-select';
import DepartmentHelper from '../../list-department/helper/department-helper';
import { FormSearchFunctionButtons } from '../../../components/form-search-wrapper-sarang/form-search-wrapper-sarang';

export const TransportOrderSearchForm = ({
    handleSubmit,
    onSubmit,
    register,
    setValue,
    now,
    control,
    branch,
    department,
    herdsmanAll,
    isTabletOrMobile,
    setOpenSearch,
    handleClearFilter
}) => {
    return (
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
            <div className="row">
                <div className="form-group col-6 col-md-4 col-lg-4 col-xl-4">
                    <label>Từ ngày</label>
                    <Controller
                        name="orderFromDate"
                        control={control}
                        render={({ onChange, value }) => (
                            <DatePicker
                                value={value ? dayjs(value) : null}
                                onChange={(data) => onChange(data ? dayjs(data).format("YYYY-MM-DD") : null)}
                                className="form-control"
                                format='DD/MM/YYYY'
                                slotProps={{ textField: { size: 'small' } }}
                            />
                        )}
                    />
                </div>

                <div className="form-group col-6 col-md-4 col-lg-4 col-xl-4">
                    <label>Đến ngày</label>
                    <Controller
                        name="orderToDate"
                        control={control}
                        render={({ onChange, value }) => (
                            <DatePicker
                                value={value ? dayjs(value) : null}
                                onChange={(data) => onChange(data ? dayjs(data).format("YYYY-MM-DD") : null)}
                                className="form-control"
                                format='DD/MM/YYYY'
                                slotProps={{ textField: { size: 'small' } }}
                            />
                        )}
                    />
                </div>
                <div className="form-group col-md-4">
                    <label>Chi hội</label>
                    <Controller
                        name="branchId"
                        control={control}
                        render={({ onChange, value }) => (
                            <Select
                                isClearable
                                value={(branch?.map(item => ({ label: item.name, value: item.id })) || []).find(x => String(x.value) === String(value)) || null}
                                onChange={(data) => onChange(data ? data.value : null)}
                                placeholder="Chọn Chi hội"
                                options={branch?.map(item => ({ label: item?.name, value: item?.id })) || []}
                                noOptionsMessage={() => "Không tồn tại"}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        )}
                    />
                </div>
            </div>
            <div className="row">
                <div className="form-group col-md-4">
                    <label htmlFor="input-department-general">Ban/Đội/Nhóm</label>
                    <Controller
                        name="departmentId"
                        control={control}
                        render={({ onChange, value }) => (
                            <DepartmentTreeSelect
                                onChange={(data) => onChange(data ? data.value : null)}
                                placeholder="Chọn Ban"
                                selected={DepartmentHelper.RenderOptions(department || []).find(x => String(x.value) === String(value)) || null}
                                options={DepartmentHelper.RenderOptions(department || [])}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        )}
                    />
                </div>
                <div className="form-group col-md-4">
                    <label htmlFor="input-department-general">Swat</label>
                    <Controller
                        name="herdsmanReceiptId"
                        control={control}
                        render={({ onChange, value }) => (
                            <Select
                                isClearable
                                placeholder="Swat"
                                value={(herdsmanAll || []).map(item => ({ label: item?.name, value: item?.id })).find(x => String(x.value) === String(value)) || null}
                                onChange={(data) => onChange(data ? data.value : null)}
                                options={(herdsmanAll || []).map(item => ({ label: item?.name, value: item?.id }))}
                                noOptionsMessage={() => "Không tồn tại"}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        )}
                    />
                </div>
                <div className="form-group col-md-4">
                    <label htmlFor="input-department-general">Trạng thái</label>
                    <Controller
                        name="status"
                        control={control}
                        render={({ onChange, value }) => (
                            <Select
                                isClearable
                                placeholder="Trạng thái"
                                value={optionsTransportOrderStatus.find(x => String(x.value) === String(value)) || null}
                                onChange={(data) => {
                                    onChange(data ? data.value : null);
                                }}
                                options={optionsTransportOrderStatus}
                                noOptionsMessage={() => "Không tồn tại"}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        )}
                    />
                </div>
            </div>
            <FormSearchFunctionButtons>
                <div className="row">
                    <div className="col-sm-12 pl-0">
                        <p className="text-center">
                            <button type="submit" className="btn btn-space btn-primary">Tìm kiếm</button>
                            <button type="button" className="btn btn-space btn-secondary" onClick={handleClearFilter}>Xóa lọc</button>
                        </p>
                    </div>
                </div>
            </FormSearchFunctionButtons>
        </form>
    );
};
